import { EngagementStatus, EngagementStepType } from '@aiwyn/api';
import { PillColor } from '@aiwyn/shared';

export interface EngagementRow {
  id: number;
  clientName: string;
  name: string;
  actionRequired: boolean;
  partnerName: string;
  startDate: string;
  status: EngagementStatusDisplayOption;
  statusColor: PillColor;
  statusDate: string;
  executedDate: string;
  paymentType: 'Scheduled Payments' | 'Manual Payment';
  paymentTypeColor: PillColor;
}

export type EngagementStatusDisplayOption = 'Ready for Review' | 'Under Revision' | 'Executed' | 'Canceled';

export const EngagementStatusDisplay: { [engagementStatus: string]: EngagementStatusDisplayOption } = {
  [EngagementStatus.SENT]: 'Ready for Review',
  [EngagementStatus.UNDER_REVISION]: 'Under Revision',
  [EngagementStatus.EXECUTED]: 'Executed',
  [EngagementStatus.CANCELED]: 'Canceled',
};

export const EngagementStatusColor: { [engagementStatus: string]: PillColor } = {
  [EngagementStatus.SENT]: 'lavender',
  [EngagementStatus.UNDER_REVISION]: 'yellow',
  [EngagementStatus.EXECUTED]: 'green',
  [EngagementStatus.CANCELED]: 'red',
};

export interface EngagementsPendingChanges {
  [engagementId: string]: EngagementPendingChanges;
}

export interface EngagementPendingChanges {
  // [EngagementStepType.LETTER]?: EngagementStepChanges; // base64 engagement letter
  [EngagementStepType.PAYMENT]: PaymentInfoStepPendingChanges;
}

export type EngagementStepPendingChanges = Partial<PaymentInfoStepPendingChanges>; // | Partial<EngagementLetterStepChanges>

export interface PaymentInfoStepPendingChanges {
  enableAutoPay: boolean;
  dayOfTheMonth: number | 'last';
  maxAmount: number;
  // termsAgreed: boolean;
}
